import React from "react";
import styles from "./top-sales-rep-section.module.scss";
import { ArrowIconComponent } from "./arrow-icon.component";
import StarIcon from "../../../icons/star.icon";

const salesData = [
  {
    name: "Sarah Chen",
    isTopPerformer: true,
    distributor: "HighGround",
    trials: 32,
    extendedTrials: 2,
    paidPlans: 12,
    expired: 4,
    churned: 4,
    conversionRate: "55%",
    mrr: "€ 4 324.00",
    arr: "€ 12 972.00",
  },
  {
    name: "David Park",
    isTopPerformer: false,
    distributor: "Portland",
    trials: 28,
    extendedTrials: 4,
    paidPlans: 10,
    expired: 3,
    churned: 4,
    conversionRate: "55%",
    mrr: "€ 3 543.00",
    arr: "€ 11 474.00",
  },
  {
    name: "Lisa Anderson",
    isTopPerformer: false,
    distributor: "Virosafe",
    trials: 24,
    extendedTrials: 8,
    paidPlans: 8,
    expired: 1,
    churned: 4,
    conversionRate: "55%",
    mrr: "€ 2 831.00",
    arr: "€ 9 932.30",
  },
  {
    name: "James Wilson",
    isTopPerformer: false,
    distributor: "Portland",
    trials: 11,
    extendedTrials: 2,
    paidPlans: 7,
    expired: 3,
    churned: 4,
    conversionRate: "55%",
    mrr: "€ 2 344.00",
    arr: "€ 5 245.00",
  },
  {
    name: "Emily Rodriguez",
    isTopPerformer: false,
    distributor: "Brigantia",
    trials: 20,
    extendedTrials: 0,
    paidPlans: 6,
    expired: 2,
    churned: 4,
    conversionRate: "55%",
    mrr: "€ 2 200.00",
    arr: "€ 5 231.00",
  },
];

const tableHeaders = [
  { label: "Sales Rep", width: "salesRepTableCellWidth217" },
  { label: "Distributor", width: "salesRepTableCellWidth126" },
  { label: "Trials", width: "salesRepTableCellWidth81" },
  { label: "Extended Trials", width: "salesRepTableCellWidth99" },
  { label: "Paid Plans", width: "salesRepTableCellWidth80" },
  { label: "Expired", width: "salesRepTableCellWidth80" },
  { label: "Churned", width: "salesRepTableCellWidth80" },
  { label: "Conversion Rate", width: "salesRepTableCellWidth112" },
  { label: "MRR", width: "salesRepTableCellWidth126" },
  { label: "ARR", width: "salesRepTableCellWidth126" },
];

export const SalesPerformanceSection = () => {
  return (
    <section className={styles.salesRepSection}>
      <div className={styles.salesRepTableContainer}>
        <div className={styles.salesRepTableHeaderRow} role="row">
          {tableHeaders.map((header, index) => (
            <div
              key={header.label}
              className={`${styles.salesRepTableCell} ${styles[header.width]} ${
                index === tableHeaders.length - 1 ? styles.salesRepTableCellLastCell : ""
              }`}
              role="columnheader"
            >
              <div
                className={`${styles.salesRepTableCellContent} ${
                  index === 2 ? styles.salesRepTableCellContentAdjusted : ""
                }`}
              >
                <div className={styles.salesRepTableHeaderText}>
                  {header.label}
                </div>
              </div>
            </div>
          ))}
        </div>

        {salesData.map((rep, index) => (
          <div key={rep.name} className={styles.salesRepTableRow} role="row">
            <div className={styles.salesRepTableCellName} role="cell">
              <div className={styles.salesRepNameContainer}>
                <div
                  className={`${styles.salesRepNameText} ${
                    rep.isTopPerformer ? styles.salesRepNameTextTopPerformer : styles.salesRepNameTextRegular
                  }`}
                >
                  {rep.name}
                </div>
                {rep.isTopPerformer && (
                  <StarIcon fill="#FFAC2C" width={15} height={14} />
                )}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth126}`}
              role="cell"
            >
              <div className={styles.salesRepTableDataText}>
                {rep.distributor}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth81}`}
              role="cell"
            >
              <div className={styles.salesRepTableDataText}>
                {rep.trials}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth99}`}
              role="cell"
            >
              <div className={styles.salesRepTableDataText}>
                {rep.extendedTrials}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth80}`}
              role="cell"
            >
              <div className={styles.salesRepTableDataText}>
                {rep.paidPlans}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth80}`}
              role="cell"
            >
              <div className={styles.salesRepTableDataText}>
                {rep.expired}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth80}`}
              role="cell"
            >
              <div className={styles.salesRepTableDataText}>
                {rep.churned}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth112}`}
              role="cell"
            >
              <div className={styles.salesRepConversionRateContainer}>
                <ArrowIconComponent isPositive={true} />
                <div className={`${styles.salesRepTableDataText} ${styles.salesRepTableDataTextSuccess}`}>
                  {rep.conversionRate}
                </div>
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth126}`}
              role="cell"
            >
              <div className={`${styles.salesRepTableDataText} ${styles.salesRepTableDataTextGray}`}>
                {rep.mrr}
              </div>
            </div>

            <div
              className={`${styles.salesRepTableDataCell} ${styles.salesRepTableDataCellWidth126} ${styles.salesRepTableDataCellLast}`}
              role="cell"
            >
              <div className={`${styles.salesRepTableDataText} ${styles.salesRepTableDataTextGray}`}>
                {rep.arr}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

